import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, Typography } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatPositiveAmount, formatNegativeAmount } from 'src/utils/formatAmout';
import { roundNumberToDecimals } from 'src/utils/common';
import dateFormatType from 'src/utils/dateFormatType';
import selectFormatDate from 'src/utils/selectDateFormat';

const FiscalCapitalBalanceScheduleRow = ({
  period,
  rawDate,
  initialBalance,
  equipmentCost,
  initialPayment,
  monthlyPrincipal,
  contribution,
  residual,
  finalBalance
}) => {
  return (
    <TableRow hover>
      <TableCell align="center">{period ?? '-'}</TableCell>
      <TableCell align="center">
        {rawDate ? selectFormatDate(rawDate, dateFormatType.MONTH_AND_YEAR) : '-'}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(initialBalance ?? 0))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(equipmentCost ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(initialPayment ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(monthlyPrincipal ?? 0, 2))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(contribution ?? 0))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(residual ?? 0))}
      </TableCell>
      <TableCell align="center">
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {formatPositiveAmount(roundNumberToDecimals(finalBalance ?? 0))}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

FiscalCapitalBalanceScheduleRow.propTypes = {
  period: PropTypes.number,
  rawDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  initialBalance: PropTypes.number,
  equipmentCost: PropTypes.number,
  initialPayment: PropTypes.number,
  monthlyPrincipal: PropTypes.number,
  contribution: PropTypes.number,
  residual: PropTypes.number,
  finalBalance: PropTypes.number
};

export default FiscalCapitalBalanceScheduleRow;


